import { Channel } from '../enums';

export const channelList: Channel[] = [Channel.EMAIL, Channel.BELL];
